import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { Company } from 'components/common/Elements/Elements';
import { isProdEnv } from 'utils/common';

const Account = ({ data }) => {
  const { customerId, companyName, country } = data;
  const { url } = useRouteMatch();
  const env = isProdEnv();
  const generateRegionalPath = useRegionalLink();

  if (env) {
    return (
      <NavLink
        to={generateRegionalPath(`${url}/${customerId}/platform/devices`)}
      >
        <Company
          nameCompany={companyName ? companyName : customerId}
          country={country}
          description={customerId}
          customerId={customerId}
        />
      </NavLink>
    );
  }

  return (
    <Company
      nameCompany={companyName ? companyName : customerId}
      country={country}
      description={customerId}
      customerId={customerId}
    />
  );
};

Account.propTypes = {
  data: PropTypes.shape({
    customerId: PropTypes.string,
    companyName: PropTypes.string,
    country: PropTypes.string
  })
};

export default Account;
